import { RootState } from 'store/rootReducer';

export const DashboardMarketingCardContentSelector = (state: RootState) => state.content.dashboardMarketingCard;
